import { Grid } from 'semantic-ui-react';
import LeadBankAccountComponent from './boxes/LeadBankAccount.component';
import LeadCompanyComponent from './boxes/LeadCompany.component';
import LeadContractComponent from './boxes/LeadContract.component';
import LeadCustomerComponent from './boxes/LeadCustomer.component';
import LeadGeneralComponent from './boxes/LeadGeneral.component';
import LeadDeliveryComponent from './boxes/LeadDelivery.component';
import LeadKYCComponent from './boxes/LeadKYC.component';
import { DetailsTransformedDataState } from '../../../types/DetailsTransformedData';
import LeadDocumentsComponent from './boxes/LeadDocuments.component';
import LeadBeneficialOwnerComponent from './boxes/LeadBeneficialOwner.component';
import LeadAuthorizedRepresentativeComponent from './boxes/LeadAuthorizedRepresentatives.component';
import LeadCreatorComponent from './boxes/LeadCreator.component';
import LeadMarketingDataComponent from './boxes/LeadMarketingData.component';
import LeadMailJetEventsComponent from './boxes/LeadMailJetEvents.component';

type LeadDetailsComponentProps = {
    detailsData: DetailsTransformedDataState;
};

/**
 * Wrapper to arrange special detail boxes. If you want to change the order by PRIVATE or BUSINESS, do it here.
 *
 * @param props LeadDetailsComponentProps
 * @returns React.ReactElement
 */
export default function LeadDetailsBoxesComponent(props: LeadDetailsComponentProps): React.ReactElement {
    const details = props.detailsData;
    let isBusiness = false;
    if (details) {
        isBusiness = !!Object.keys(props.detailsData.company).length;
    }

    return (
        <div>
            {details && (
                <Grid columns={3}>
                    <Grid.Column>
                        <LeadGeneralComponent data={details.general} copy />
                        {details.leadCreator && <LeadCreatorComponent leadCreator={details.leadCreator} copy />}
                        <LeadKYCComponent data={details.kyc} signers={details.signers} copy />
                        <LeadDocumentsComponent
                            isBusiness={isBusiness}
                            onboardingDocuments={details.documents.onboardingFlowDocuments}
                            kycDocument={details.documents.kycDocument}
                        />
                        <LeadMarketingDataComponent marketingData={details.marketingData} />
                    </Grid.Column>
                    <Grid.Column>
                        <LeadContractComponent data={details.contract} copy />
                        <LeadDeliveryComponent data={details.delivery} copy />
                        <LeadMailJetEventsComponent />
                    </Grid.Column>

                    <Grid.Column>
                        {isBusiness ? (
                            <>
                                <LeadCompanyComponent data={details.company} copy />
                                <LeadAuthorizedRepresentativeComponent data={details.authorizedRepresentatives} copy />
                                <LeadBeneficialOwnerComponent data={details.beneficialOwners} copy />
                                <LeadBankAccountComponent data={details.bankAccount} copy />
                                {!details.leadCreator && (
                                    <LeadCustomerComponent data={details.customer} type={details.general.type} copy />
                                )}
                            </>
                        ) : (
                            <>
                                <LeadCustomerComponent data={details.customer} type={details.general.type} copy />
                                <LeadBankAccountComponent data={details.bankAccount} copy />
                            </>
                        )}
                    </Grid.Column>
                </Grid>
            )}
        </div>
    );
}
